import Icon from '../components/Icon.vue'

Icon.register({
  'radiation-alt': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M312 256c0-22.8-12.1-42.8-30.1-54l41.7-66.8c5.2-8.3 16.4-9.9 24-3.8 32.5 26 54.9 64.2 59.5 107.8 0.9 9.1-6.8 16.8-16 16.8h-79.1zM214.2 310.1c9.8 6.2 21.5 9.9 33.9 9.9 12.4 0 24-3.7 33.8-9.9l41.8 66.9c4.8 7.8 2.4 18.4-5.8 22.5-21.2 10.4-44.8 16.5-69.9 16.5s-48.7-6.1-69.8-16.5c-8.2-4.1-10.7-14.7-5.8-22.5zM104.9 256c-9.2 0-17-7.7-15.9-16.9 4.6-43.6 26.9-81.8 59.5-107.8 7.6-6.1 18.8-4.5 24 3.8l41.7 66.8c-18.1 11.3-30.2 31.3-30.2 54.1h-79.1zM248 504c-137 0-248-111-248-248s111-248 248-248 248 111 248 248-111 248-248 248zM248 72c-101.5 0-184 82.5-184 184s82.5 184 184 184 184-82.5 184-184-82.5-184-184-184zM248 288c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/radiation-alt.js
// module id = 1675
// module chunks = 0